var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
            ]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/customers/customersTag" } } },
              [_c("div", { staticClass: "div2" }, [_vm._v("客户标签管理")])]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "el-tabs",
          {
            staticClass: "tabs",
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c("el-tab-pane", {
              attrs: { label: "行为标签", name: "behaviorTags" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm.activeName == "behaviorTags"
      ? _c("div", { staticClass: "headerbox" }, [
          _c("div", { staticClass: "header" }, [_vm._v(" 行为标签 ")]),
          _c("div", { staticClass: "behaviorTags-content" }, [
            _c(
              "div",
              { staticClass: "behaviorTags-content-left" },
              [
                _c("el-tree", {
                  ref: "behaviorTree",
                  attrs: {
                    data: _vm.behaviorTagTable,
                    "node-key": "id",
                    "current-node-key": _vm.dataId,
                  },
                  on: { "node-click": _vm.handleNodeClick },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "behaviorTags-content-right" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.behaviorTagsList },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "id", label: "序号", width: "60" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(" " + _vm._s(scope.$index + 1) + " "),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3056706777
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "标签组名称", prop: "groupName" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [_vm._v(_vm._s(props.row.groupName))]
                            },
                          },
                        ],
                        null,
                        false,
                        2026552357
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "标签值", "min-width": "300" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _vm._v(_vm._s(props.row.tagValues.join(","))),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3239997526
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", "min-width": "100" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 2,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleSwitchChange(props.row)
                                    },
                                  },
                                  model: {
                                    value: props.row.status,
                                    callback: function ($$v) {
                                      _vm.$set(props.row, "status", $$v)
                                    },
                                    expression: "props.row.status",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        730744542
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }